import { useAdminFetchAgencyPreviews } from "@portal/api/agency/admin";
import { Spinner } from "@portal/components/ui/Spinner";
import { Tooltip } from "react-tooltip";

export const AgencyCellView = ({ agencyId }: { agencyId: string }) => {
	const { agencyNameMap, agencyPreviewsLoading } = useAdminFetchAgencyPreviews();
	if (agencyPreviewsLoading) {
		return <Spinner />;
	}
	return (
		<>
			<span className="truncate" data-tooltip-id={`agency-tooltip-${agencyId}`}>
				{agencyNameMap[agencyId]}
			</span>
			<Tooltip
				offset={-29} // Center over text
				id={`agency-tooltip-${agencyId}`}
				content={agencyNameMap[agencyId] || "--"}
				className="px-0 text-gray-700 text-[15px]"
				delayShow={350}
				style={{
					background: "rgba(251,252,253,1)", // match the DataTable hover bg color
					fontSize: "15px",
				}}
				noArrow
				variant="light"
			/>
		</>
	);
};
